import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { RelayEnvironmentProvider } from "react-relay";
import RelayEnvironment from "./RelayEnvironment";
import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { teal } from "@mui/material/colors";
import Dashboard from "./dashboard/Dashboard";
import RunnersDashboard from "./dashboard/RunnersDashboard";
import { SnackbarProvider } from "notistack";
import CacheDashboard from "./dashboard/CacheDashboard";
import { TransportProvider } from "@connectrpc/connect-query";
import { createConnectTransport } from "@connectrpc/connect-web";
import { QueryClientProvider } from "@tanstack/react-query";
import { QueryClient } from "@tanstack/query-core";
import { ConnectError } from "@connectrpc/connect";
import InsightsDashboard from "./dashboard/InsightsDashboard";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const transport = createConnectTransport({
  baseUrl: "/",
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount: number, error: Error) => {
        // Do not retry ConnectRPC errors because all the
        // gRPC-like errors our backend returns are fatal
        return !(error instanceof ConnectError);
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <RelayEnvironmentProvider environment={RelayEnvironment}>
      <TransportProvider transport={transport}>
        <QueryClientProvider client={queryClient}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider
              theme={createTheme({
                palette: {
                  primary: {
                    main: teal[500],
                  },
                  secondary: {
                    main: teal[400],
                  },
                },
              })}
            >
              <CssBaseline />
              <SnackbarProvider
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              >
                <BrowserRouter>
                  <Routes>
                    <Route path={"/"} element={<App />}>
                      <Route
                        path="/dashboard"
                        element={<Dashboard />}
                        caseSensitive={true}
                      />
                      <Route
                        path="/dashboard/:organization"
                        element={<RunnersDashboard />}
                        caseSensitive={true}
                      />
                      <Route
                        path="/dashboard/:organization/insights"
                        element={<InsightsDashboard />}
                        caseSensitive={true}
                      />
                      <Route
                        path="/dashboard/:organization/cache/*"
                        element={<CacheDashboard />}
                        caseSensitive={true}
                      />
                    </Route>
                  </Routes>
                </BrowserRouter>
              </SnackbarProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </QueryClientProvider>
      </TransportProvider>
    </RelayEnvironmentProvider>
  </React.StrictMode>,
);
